export const GET_CONTRACTS_TYPE: '@contract/GET_CONTRACTS_TYPE' =
  '@contract/GET_CONTRACTS_TYPE';
export const SET_CONTRACTS_TYPE: '@contract/SET_CONTRACTS_TYPE' =
  '@contract/SET_CONTRACTS_TYPE';
export const MATCH_CONTRACT_SUCCESS: '@contract/MATCH_CONTRACT_SUCCESS' =
  '@contract/MATCH_CONTRACT_SUCCESS';
export const GET_CONTRACTS_AUTO: '@contract/GET_CONTRACTS_AUTO' =
  '@contract/GET_CONTRACTS_AUTO';
export const SET_CONTRACTS_AUTO: '@contract/SET_CONTRACTS_AUTO' =
  '@contract/SET_CONTRACTS_AUTO';
export const GET_CONTRACTS_AUTO_FAILED: '@contract/GET_CONTRACTS_AUTO_FAILED' =
  '@contract/GET_CONTRACTS_AUTO_FAILED';
export const SET_CONTRACT_INFO: '@contract/SET_CONTRACT_INFO' =
  '@contract/SET_CONTRACT_INFO';
export const GET_CONTRACT_DETAIL: '@contract/GET_CONTRACT_DETAIL' =
  '@contract/GET_CONTRACT_DETAIL';
export const SET_CONTRACT_DETAIL: '@contract/SET_CONTRACT_DETAIL' =
  '@contract/SET_CONTRACT_DETAIL';
export const GET_CONTRACT_DETAIL_FAILED: '@contract/GET_CONTRACT_DETAIL_FAILED' =
  '@contract/GET_CONTRACT_DETAIL_FAILED';
export const SET_CONTRACT_DETAIL_FILES: '@contract/SET_CONTRACT_DETAIL_FILES' =
  '@contract/SET_CONTRACT_DETAIL_FILES';
export const SET_CONTRACT_DETAIL_SERVICES: '@contract/SET_CONTRACT_DETAIL_SERVICES' =
  '@contract/SET_CONTRACT_DETAIL_SERVICES';
export const SET_CONTRACT_DETAIL_GARANTIES: '@contract/SET_CONTRACT_DETAIL_GARANTIES' =
  '@contract/SET_CONTRACT_DETAIL_GARANTIES';
export const GET_CONTRACTS_MRH: '@contract/GET_CONTRACTS_MRH' =
  '@contract/GET_CONTRACTS_MRH';
export const SET_CONTRACTS_MRH: '@contract/SET_CONTRACTS_MRH' =
  '@contract/SET_CONTRACTS_MRH';
export const GET_CONTRACTS_MRH_FAILED: '@contract/GET_CONTRACTS_MRH_FAILED' =
  '@contract/GET_CONTRACTS_MRH_FAILED';
export const ADD_NEW_CONTRACT: '@contract/ADD_NEW_CONTRACT' =
  '@contract/ADD_NEW_CONTRACT';
export const ADD_NEW_CONTRACT_FAILED: '@contract/ADD_NEW_CONTRACT_FAILED' =
  '@contract/ADD_NEW_CONTRACT_FAILED';
export const OPEN_MODAL_SUCCESS_CONTRACT: '@contract/OPEN_MODAL_SUCCESS_CONTRACT' =
  '@contract/OPEN_MODAL_SUCCESS_CONTRACT';
export const CLOSE_MODAL_SUCCESS_CONTRACT: '@contract/CLOSE_MODAL_SUCCESS_CONTRACT' =
  '@contract/CLOSE_MODAL_SUCCESS_CONTRACT';
export const CLOSE_ADD_NEW_CONTRACT_MODAL: '@contract/CLOSE_ADD_NEW_CONTRACT_MODAL' =
  '@contract/CLOSE_ADD_NEW_CONTRACT_MODAL';
export const OPEN_ADD_NEW_CONTRACT_MODAL: '@contract/OPEN_ADD_NEW_CONTRACT_MODAL' =
  '@contract/OPEN_ADD_NEW_CONTRACT_MODAL';
export const GET_DETAILS_CONTRACT_MRH: '@contract/GET_DETAILS_CONTRACT_MRH' =
  '@contract/GET_DETAILS_CONTRACT_MRH';
export const SET_DETAILS_CONTRACT_MRH: '@contract/SET_DETAILS_CONTRACT_MRH' =
  '@contract/SET_DETAILS_CONTRACT_MRH';
export const SET_DETAILS_CONTRACT_MRH_FAILED: '@contract/SET_DETAILS_CONTRACT_MRH_FAILED' =
  '@contract/SET_DETAILS_CONTRACT_MRH_FAILED';
export const SET_DETAILS_CONTRACT_MRH_GARANTIES: '@contract/SET_DETAILS_CONTRACT_MRH_GARANTIES' =
  '@contract/SET_DETAILS_CONTRACT_MRH_GARANTIES';
export const SET_DETAILS_CONTRACT_MRH_FILES: '@contract/SET_DETAILS_CONTRACT_MRH_FILES' =
  '@contract/SET_DETAILS_CONTRACT_MRH_FILES';
export const GET_CONTRACTS_EPARGN: '@contract/GET_CONTRACTS_EPARGN' =
  '@contract/GET_CONTRACTS_EPARGN';
export const SET_CONTRACTS_EPARGN: '@contract/SET_CONTRACTS_EPARGN' =
  '@contract/SET_CONTRACTS_EPARGN';
export const GET_CONTRACTS_EPARGN_FAILED: '@contract/GET_CONTRACTS_EPARGN_FAILED' =
  '@contract/GET_CONTRACTS_EPARGN_FAILED';
export const GET_PRODUIT_EPARGN: '@contract/GET_PRODUIT_EPARGN' =
  '@contract/GET_PRODUIT_EPARGN';
export const SET_PRODUIT_EPARGN_SUCCESS: '@contract/SET_PRODUIT_EPARGN_SUCCESS' =
  '@contract/SET_PRODUIT_EPARGN_SUCCESS';
export const GET_PRODUIT_EPARGN_FAILED: '@contract/GET_PRODUIT_EPARGN_FAILED' =
  '@contract/GET_PRODUIT_EPARGN_FAILED';
export const SET_AUTH_CONTRACT_EPARGN_INFO: '@contract/SET_AUTH_CONTRACT_EPARGN_INFO' =
  '@contract/SET_AUTH_CONTRACT_EPARGN_INFO';
export const GET_CONTRACTS_AMC: '@global/GET_CONTRACTS_AMC' =
  '@global/GET_CONTRACTS_AMC';
export const SET_CONTRACTS_AMC: '@global/SET_CONTRACTS_AMC' =
  '@global/SET_CONTRACTS_AMC';
export const GET_CONTRACTS_AMC_FAILED: '@global/GET_CONTRACTS_AMC_FAILED' =
  '@global/GET_CONTRACTS_AMC_FAILED';
export const SET_CONTRACT_AMC_BENEFICIARIES: '@global/SET_CONTRACT_AMC_BENEFICIARIES' =
  '@global/SET_CONTRACT_AMC_BENEFICIARIES';
export const GET_CONTRACT_AMC_BENEFICIARIES_FAILED: '@global/GET_CONTRACT_AMC_BENEFICIARIES_FAILED' =
  '@global/GET_CONTRACT_AMC_BENEFICIARIES_FAILED';
export const GET_CLIENT_CONTRACT_ASI: '@contract/GET_CLIENT_CONTRACT_ASI' =
  '@contract/GET_CLIENT_CONTRACT_ASI';
export const SET_CLIENT_CONTRACT_ASI: '@contract/SET_CLIENT_CONTRACT_ASI' =
  '@contract/SET_CLIENT_CONTRACT_ASI';
export const GET_CONTRACTS_AMC_DETAIL: '@contract/GET_CONTRACTS_AMC_DETAIL' =
  '@contract/GET_CONTRACTS_AMC_DETAIL';
export const SET_CONTRACTS_AMC_DETAIL: '@contract/SET_CONTRACTS_AMC_DETAIL' =
  '@contract/SET_CONTRACTS_AMC_DETAIL';
